import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSection';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import {toast} from "react-toastify";
import axios from "../../../services/interceptor/Interceptor";
import Config from "services/config/config";
import { handleValidateObj } from 'constants/objValues/objvalues';
import DivLayout from 'components/sales/divLayout/divLayout';
import "./pos.css";
import { is } from 'date-fns/locale';

const PosShipment = ({
  match,
  location,
  updateStatus,
  getSiteData,
  siteDetails,
  calculateDistance,
  engDistanceData,
  getDistanceData,
  distanceDetails,
  getPosShipment,
  posRequirement,
  updateStatusPos
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [poclist, setPocList] = useState([]);
  const [modal, setModal] = useState(false);
  const emailModalHide = () => setModal(false);
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState('');
  const [opened, setIsOpened] = useState(false);
  const [materialArray, setMaterialArray] = useState([]);
  const [duplicateData, setDuplicateData] = useState([]);
  const [isShow, setIsShow] = useState(true);
  const [details, setDetails] = useState([]);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [otpVal,setOTP] = useState('');
  
  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
    setIsOpen(!isOpen);
  }, [])

  useEffect( () => {
    (async () => {
      await getDistanceData(match.params.id, 'tag-delivery')
    })()
  }, [])

  useEffect( () => {
    setIsOpen(true)
    if(distanceDetails !== undefined && Object.keys(distanceDetails).length > 0){
      if(!distanceDetails['total_hours']){
        setIsOpen(false);
      }
    }
  }, [distanceDetails])


  useEffect( () => {
    if(engDistanceData !== null && Object.keys(engDistanceData).length > 0){
      toast.success('Distance is successfully fetched');
      setIsOpen(false);
      Object.keys(engDistanceData).forEach(key => {
        delete engDistanceData[key];
      })
    }else if(engDistanceData === null){
      toast.success('Distance is not fetched');
      setIsOpen(true);
    }
  }, [engDistanceData])
    

  useEffect(() => {
    if (getPosShipment !== null && match.params.id);
    (async () => {
      setIsLoading(true);
      await getPosShipment(match.params.id);
      setIsLoading(false);
    })();
  },[getPosShipment,match.params.id]);

  const handleStatusUpdate = async () => {
    var isError = false;
    if(otpVal == '') {
      toast.error('Please enter OTP.');
      return false;
    }
    materialArray.map((val) => {
      if(!handleValidateObj(val)) {
        isError = true;
      }
    });
      
    if(isError) {
       toast.error('Please select serial number against all materials.');
       return false;
    }
    setDisabledBtn(true);
    setIsLoading(true);
    var payload = {
      'site_id':match.params.id,
      'stage_id':match.params.stageId,
      'mat_data':materialArray,
      'otp': otpVal
    }
    //console.log(JSON.stringify(payload)); return false;
    const res = await updateStatusPos(payload);
    if (res === true) {   
        setIsLoading(false);
        toast.success('Stage completed.');
        setTimeout(() => {
          window.location.reload()
      }, 4500);
    } else {
      toast.error('Stage not completed.');
      setDisabledBtn(false);
    }
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
          <Button
            disabled={disabledBtn}
            className="btn btn-primary"
            onClick={() => handleStatusUpdate()}
          >
            {localization.stageCompleted}
          </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    if(posRequirement !== undefined) {
      // console.log('dd ' + JSON.stringify(posRequirement.materials));
      if(posRequirement?.details != undefined && posRequirement?.details?.length > 0) {
          setDetails(posRequirement?.details);
          setIsShow(false);
      } else {
          const list = [...materialArray];
          var data = posRequirement.materials;
          for(var i=0; i<data?.length; i++) {
            list[i] = {'mat_id':data[i]?.material_id,'mat_name':data[i].material_name,'mat_code':data[i].material_code,'erp_serial_no':data[i].erp_serial_number,'serial_number':''};
          }
          setMaterialArray([...list]);
      }
    }
  },[posRequirement]);

  const handleValue = (val,key,index) => {
    if(val) {
      var flag = false;
      let list = [...materialArray];
      if(duplicateData.includes(val)) {
        toast.error('Serial number already selected');
        flag = false;
      } else {
        duplicateData.push(val);
        flag = true;
      }
      //REmove from duplicate array
      if(list[index][key] !== undefined) {
        const position = duplicateData.indexOf(list[index][key]);
        if(position > -1) { 
           duplicateData.splice(position, 1); 
        }
      } 
      if(list[index][key] == ' '){
        list[index][key] = (flag) ? val : '';
      } else{
        list[index][key] = (flag) ? val : ' ';
      }
      setMaterialArray([...list]);
    }
    //console.log('data ' + JSON.stringify(materialArray));
  }
  //console.log('koko - ' + duplicateData);

  return (
    <Layout
      title={localization.posShipment}
      Buttons={(isShow) ? headerBtns : null}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkFlag={true}
      linkUrl={`/dashboard/site-stage/${match.params.id}`}
      isLoading={isLoading}
    >

      {role === 9 && isOpen && opened ?
          <div className="popup-box">
            <div className="box">
              {siteDetails?.lead_id !== undefined &&
              <Link
                to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
                className="btn btn-primary mb-4"
                style={{'cursor': 'pointer','border':'0px','box-shadow':'none !important','position':'relative','top':'-17px',
                  'float':'right'}}
            >
              x
            </Link>
              }

              <DistanceCalculator
                  siteData={siteDetails}
                  getSiteData={getSiteData}
                  calculateDistance={calculateDistance}
                  siteId={match.params.id}
                  moduleType={'tag-delivery'}
                  to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
              />
            </div>
          </div> :
          <>
          <FormSection title={localization.pos}>
            <div className="panel-body" style={{'marginBottom':'3rem'}}>
            {isShow && materialArray && materialArray.length > 0 &&
            <>
            {materialArray.map((value,key) => {
              return (
              <>  
              <div className='row auto-w-100' key={key}>
              <div className='col-md-6'>
              <ConstantInput
                  label={localization.material + ` `+ (key+1)}
                  isStarRequired={false}
                  disabled={true}
                  value={value?.mat_name}
                  errorMsg={localization.isRequired}
              />
              </div>
              <div className='col-md-6'>
              <DropDownInput
                name="serial_number"
                data={value?.erp_serial_no}
                label={localization.serialNo}
                required={true}
                isStarRequired={true}
                errorMsg={localization.isRequired}
                getIdValue={(val) => handleValue(val.id,'serial_number',key)}
                value={value?.serial_number ?? ''}
              />
              </div>
              </div>
              </>
              )
             })}
             <hr />
             <div className='row'>
               <div className='col-md-6'>
               <ConstantInput
                  label={`Enter OTP`}
                  isStarRequired={true}
                  value={otpVal}
                  type={`number`}
                  maxLength={4}
                  errorMsg={localization.isRequired}
                  handleChange={(val) => {
                        setOTP(val);
                  }}
               />
               </div>
              </div>
             </>
            }

            {details && details.length > 0 && details.map((val,i) => {
              return (
              <div class="row auto-design" key={i}>  
              <div className={`details-listing`}>
              <div className='col-md-4'>
                <DivLayout
                  heading={'Material'}
                  data={val?.material_name}
                />
              </div>
              <div className='col-md-4'>  
                <DivLayout
                  heading={'Serial Number'}
                  data={val?.serial_number}
                />
              </div>  
              <div className='col-md-4'>  
                <DivLayout
                  heading={'Status'}
                  data={(parseInt(val?.status) === 1) ? 'Mapped' : (parseInt(val?.status) === 2) ? 'Replaced' : (parseInt(val?.status) === 3) ? 'Returned' : 'NA'}
                />
              </div> 
              </div>
              </div>
              )
            })}
            
            </div>
          </FormSection>
          </>
      }
    </Layout>
  );
};
export default PosShipment;
